import React from "react";

const LoadingSpinner = () => {
  return (
    <>
      <div className="spinner mt-2" />
      <h3>Loading ...</h3>
    </>
  );
};

export default LoadingSpinner;
